import React from "react";
import { FaImage } from "react-icons/fa";
import useSystemVariable from "./shared/useSystemVariable";
import SystemVariablePage from "./shared/SystemVariablePage";
import { normalizeHeader, pickCell, downloadExcelTemplate } from "./shared/excelUtils";
import {
  useListImagesMutation, useCreateImageMutation,
  useUpdateImageMutation, useDeleteImageMutation,
  useBulkUpsertImagesMutation,
} from "../../store/systemVariablesApi";

const mapExcelRow = (row) => {
  const n = {};
  Object.keys(row || {}).forEach((k) => { n[normalizeHeader(k)] = row[k]; });
  const name = pickCell(n, ["görüntü", "görüntü adı", "goruntu", "goruntu adi", "ad", "isim", "name"]);
  return { name: name ? String(name).trim() : "" };
};

const TEMPLATE_ROWS = [
  { "Görüntü Adı": "Akciğer PA grafisi" },
  { "Görüntü Adı": "Batın USG" },
  { "Görüntü Adı": "Beyin MR" },
  { "Görüntü Adı": "Tiroid USG" },
  { "Görüntü Adı": "Lomber MR" },
  { "Görüntü Adı": "Batın BT" },
  { "Görüntü Adı": "Ekokardiyografi" },
  { "Görüntü Adı": "Doppler USG" },
];

export default function Images() {
  const vm = useSystemVariable({
    listMutation: useListImagesMutation(),
    createMutation: useCreateImageMutation(),
    updateMutation: useUpdateImageMutation(),
    deleteMutation: useDeleteImageMutation(),
    bulkMutation: useBulkUpsertImagesMutation(),
    itemsKey: "images",
    idKey: "imageId",
    defaultForm: { name: "" },
    itemToForm: (it) => ({ name: it?.name || "" }),
    formToPayload: (form) => ({ name: form.name }),
    entityLabel: "Görüntü",
  });

  return (
    <SystemVariablePage
      icon={<FaImage size={22} />}
      title="Görüntü Şablonları"
      subtitle={<>Görüntüleme isteklerinde seçilecek liste. Zorunlu alan: <b>Görüntü Adı</b></>}
      entityLabel="Görüntü"
      vm={vm}
      tableColumns={[{ key: "name", label: "Görüntü Adı", bold: true }]}
      formFields={[{ key: "name", label: "Görüntü Adı", required: true }]}
      importColumns={[{ key: "name", label: "Görüntü Adı", bold: true }]}
      mapExcelRow={mapExcelRow}
      downloadTemplate={() => downloadExcelTemplate(TEMPLATE_ROWS, "Görüntüler", "goruntu_sablonu.xlsx")}
    />
  );
}
